module.exports = __webpack_public_path__ + "static/img/firebase_white.4448721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/firebase_white.png
// module id = omcL
// module chunks = 1